const evidence = {
  title: 'Evidence',
  empty: 'No evidence is linked to this finding yet.',
  error: 'The evidence could not be loaded. Please try again shortly.',
  noAnchor: 'No anchor',
  copyReference: 'Copy reference details',
  pageUnknown: 'The exact location was not recorded. Open the document to check.',
  unversioned: 'Unversioned',
  retrievedAt: 'Retrieved at',
  sourceRevision: 'Source revision',
  generatorVersion: 'Generator version',
  openPage: 'Open page {{page}}',
  openDocument: 'Open the document',
  missingRevisionContext: 'This finding has no design-change revision, so its evidence cannot be requested.',
  errorPermanent: 'The evidence for this finding cannot be retrieved. Check the configuration or the source data.',
  unrenderable: 'This finding does not name its generator version, so its evidence cannot be shown.',
  loading: 'Loading evidence…',
  notCarried: 'Not carried into evidence',
  conversionNote: {
    missing_source_revision: 'No source revision, so the reference cannot be pinned to a version.',
    unsupported_locator: 'No locator that identifies where in the source to go.',
    unsupported_source_type: 'This source type cannot be treated as evidence.',
    unknown: 'The reason could not be determined.',
  },
  copied: 'Reference details copied.',
  copyFailed: 'Could not copy. Please select the text manually.',
  status: {
    unverified: 'Not yet verified',
    verified: 'Verified',
    missing: 'Evidence missing',
    stale: 'Revision is stale',
    unsupported: 'Evidence unsupported',
    conflict: 'Evidence conflicts',
    withheld: 'Evidence cannot be shown',
    unknown: 'State unknown',
  },
  sourceType: {
    document_page: 'Document page',
    standard_clause: 'Standard',
    past_trouble: 'Past trouble',
    geometry_calculation: 'Geometry calculation',
    unknown: 'Unknown source type',
    model_output: 'Model output',
  },
  reason: {
    permissionDenied: 'You are not permitted to see where this source is, so it cannot be opened.',
    sourceDeleted: 'The referenced document has been deleted.',
    unsupportedLocator: 'The source does not point at a document, so no destination can be resolved.',
    unsupportedSourceType: 'This source type has no in-app destination to open.',
  },
  availability: {
    partially_unavailable: 'Some sources cannot be opened',
    unavailable: 'Sources cannot be opened',
  },
  contractMismatch: 'The evidence service returned data this screen cannot interpret. Please contact your administrator.',
  errorPermissionDenied: 'You are not permitted to view the evidence for this finding.',
  missingRetrievalTime: 'This finding has no creation time, so a retrieval time for its evidence cannot be recorded.',
  anchorMaturity: {
    unknown: 'Anchor of unknown maturity',
    no_anchor: 'No anchor',
    candidate_anchor: 'AI-suggested anchor',
    manual_anchor: 'Manual anchor',
    verified_anchor: 'Verified anchor',
    rejected_anchor: 'Rejected anchor',
    stale_anchor: 'Stale anchor',
    superseded_anchor: 'Superseded anchor',
  },
};

export default evidence;
